<m-link class="m-add"
        :disabled="disabled"
        :icon-position="iconPosition"
        :icon-size="iconSize"
        :skin="skin"
        :underline="underline"
        icon-name="m-svg__add-circle-filled"
        mode="button"
        @click="onClick">
    <slot />
</m-link>
